import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonBase } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ALL, ACTIVE, INACTIVE } from "../../consts/driverDetails";
import { palette } from "../../theme/palette";

import { sectionViewSelector } from "../../reducers/sectionManagement/selectors";
import { setSectionView } from "../../reducers/sectionManagement/thunkActions";

import { AllSections, ActiveSections, InactiveSections } from "../Icons";
import { View } from "../View";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "white",
    "& svg": {
      height: "32px",
      width: "32px",
      cursor: "pointer",
    },
  },
  padding: {
    height: "28px !important",
    width: "28px !important",
    paddingTop: "2px",
    paddingBottom: "2px",
  },
});

export const SectionViews = memo(() => {
  const view = useSelector(sectionViewSelector);
  const dispatch = useDispatch();
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <ButtonBase
        onClick={() => {
          dispatch(setSectionView(ACTIVE));
        }}
        disableRipple={true}
      >
        <ActiveSections
          fill={
            view === ACTIVE ? palette.orange : palette.typography.white.high
          }
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setSectionView(INACTIVE));
        }}
        disableRipple={true}
      >
        <InactiveSections
          fill={
            view === INACTIVE ? palette.orange : palette.typography.white.high
          }
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setSectionView(ALL));
        }}
        disableRipple={true}
      >
        <AllSections
          className={styles.padding}
          fill={view === ALL ? palette.orange : palette.typography.white.high}
        />
      </ButtonBase>
    </View>
  );
});

export default SectionViews;
